<template>
  <div class="ibox-body">
    <div class="ibox-title style_2" style="display: flex; justify-content: space-between; align-items: center;">
      <h5>{{ title }}</h5>
      <div v-if="rollsprivilages.includes('Study Profile Create Visit')" class="position-relative align-self-center" aria-label="Create Visit" tabindex="0">
        <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="15" alt="Create Visit"
          @click.prevent="visitPopup(0, '')" />
        <div class="tool-tip">{{ $t("navigations.create visit") }}</div>
      </div>
    </div>

    <!-- LOADING -->
    <div class="text-center" v-if="loading === true">
      <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
      <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
    </div>

    <div v-else class="ibox-content horizondalscroll" id="scrollBody">
      <ul class="tree pl-1">
        <template v-for="(node, nodeIndex) in visitTreeList"
          :key="`visit-node-${node?.type || 'unknown'}-${node?.visit?.visitId || node?.cycleId || nodeIndex}`">

          <!-- ROOT SOA -->
          <li v-if="node && node.type === 'soa'">

            <input type="checkbox" :id="'soa-' + node.soaId" />

            <label class="tree_label" :for="'soa-' + node.soaId">
              {{ node.displayText }}
            </label>

            <ul>

              <template v-for="(soaChild, soaIndex) in node.nodes" :key="'soa-child-' + soaIndex">

                <!-- ================= PHASE under SOA ================= -->
                <li v-if="soaChild && soaChild.type === 'phase'">

                  <input type="checkbox" :id="`phase-${node.soaId}-${soaChild.phaseName}`" />

                  <label class="tree_label" :for="`phase-${node.soaId}-${soaChild.phaseName}`">
                    {{ soaChild.displayText }}
                  </label>

                  <ul>

                    <template v-for="(child, childIndex) in soaChild.nodes" :key="'phase-node-' + childIndex">

                      <!-- VISIT under PHASE under SOA -->
                      <li v-if="child && child.type === 'visit'">

                        <div class="d-flex justify-content-between align-items-center">

                          <div class="w-100">
                            <input type="checkbox" :id="visitInputId(child.visit)"
                              @change="toggleVisit(child.visit.__visitIndex, child.visit.visitId)" />

                            <label class="tree_label" :for="visitInputId(child.visit)">
                              {{ child.visit.visitNo }} : {{ child.visit.visitFormName }}
                            </label>
                          </div>

                          <div class="d-flex align-items-center gap-3" v-if="optionsshow">
                            <div class="position-relative">
                              <button :popovertarget="'visit-popup-' + child.visit.visitId"
                                :style="{ anchorName: '--visit-popup-' + child.visit.visitId }"
                                class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                                <i class="fa fa-ellipsis-v"></i>
                              </button>

                              <div :id="'visit-popup-' + child.visit.visitId" popover class="tmf-docs-popup-menu"
                                :style="{ positionAnchor: '--visit-popup-' + child.visit.visitId }"
                                @click.stop>

                                <button class="popup-menu-block text-start"
                                  @click.prevent="visitPopup(child.visit.visitId)">
                                  {{ $t('navigations.edit') }}
                                </button>

                                <button class="popup-menu-block text-start"
                                  @click.prevent="deleteVisit(child.visit.visitId)">
                                  {{ $t('navigations.delete') }}
                                </button>

                                <button class="popup-menu-block text-start"
                                  @click.prevent="openVisitActivityModal(child.visit.visitId)">
                                  {{ $t('navigations.assign activity') }}
                                </button>

                              </div>
                            </div>
                          </div>

                        </div>

                        <!-- ACTIVITIES -->
                        <div v-if="visitExpanded[child.visit.__visitIndex]">

                          <ul v-for="(activity, aIndex) in activityList[child.visit.visitId][child.visit.__visitIndex]"
                            :key="activity.activityId">

                            <li>

                              <input type="checkbox" :id="activity.activityId + child.visit.visitId"
                                @change="getActivityForms(activity.activityId, aIndex)" />

                              <label :for="activity.activityId + child.visit.visitId" class="tree_label">
                                {{ activity.activityOrder }} : {{ activity.activityName }}
                              </label>

                              <!-- FORMS -->
                              <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                                <li>

                                  <label :for="form.templateId" class="tree_form">
                                    {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                                  </label>

                                  <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                                </li>

                              </ul>

                            </li>

                          </ul>

                        </div>

                      </li>
                      <!-- CYCLE under PHASE under SOA -->
                      <li v-else-if="child && child.type === 'cycle'">

                        <input type="checkbox" :id="`cycle-${child.cycleId || 'unknown'}-${childIndex}`" />

                        <label class="tree_label" :for="`cycle-${child.cycleId || 'unknown'}-${childIndex}`">
                          {{ child.displayText }}
                        </label>

                        <ul>

                          <li v-for="cycleVisit in child.visits" :key="cycleVisit.visitId">

                            <div class="d-flex justify-content-between align-items-center">

                              <div class="w-100">

                                <input type="checkbox" :id="visitInputId(cycleVisit)"
                                  @change="toggleVisit(cycleVisit.__visitIndex, cycleVisit.visitId)" />

                                <label class="tree_label" :for="visitInputId(cycleVisit)">
                                  {{ cycleVisit.visitNo }} :
                                  {{ cycleVisit.visitFormName }}
                                </label>

                              </div>

                              <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">

                                <div class="position-relative">

                                  <button :popovertarget="'visit-popup-' + cycleVisit.visitId"
                                    :style="{ anchorName: '--visit-popup-' + cycleVisit.visitId }"
                                    class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                                    <i class="fa fa-ellipsis-v"></i>
                                  </button>

                                  <div :id="'visit-popup-' + cycleVisit.visitId" popover class="tmf-docs-popup-menu"
                                    :style="{ positionAnchor: '--visit-popup-' + cycleVisit.visitId }"
                                    @click.stop>

                                    <button class="popup-menu-block text-start"
                                      @click.prevent="visitPopup(cycleVisit.visitId)">
                                      {{ $t('navigations.edit') }}
                                    </button>

                                    <button class="popup-menu-block text-start"
                                      @click.prevent="deleteVisit(cycleVisit.visitId)">
                                      {{ $t('navigations.delete') }}
                                    </button>

                                    <button class="popup-menu-block text-start"
                                      @click.prevent="openVisitActivityModal(cycleVisit.visitId)">
                                      {{ $t('navigations.assign activity') }}
                                    </button>

                                  </div>

                                </div>

                              </div>

                            </div>

                            <!-- ACTIVITIES -->
                            <div v-if="visitExpanded[cycleVisit.__visitIndex]">

                              <ul
                                v-for="(activity, aIndex) in activityList[cycleVisit.visitId][cycleVisit.__visitIndex]"
                                :key="activity.activityId">

                                <li>

                                  <input type="checkbox" :id="activity.activityId + cycleVisit.visitId"
                                    @change="getActivityForms(activity.activityId, aIndex)" />

                                  <label :for="activity.activityId + cycleVisit.visitId" class="tree_label">
                                    {{ activity.activityOrder }} :
                                    {{ activity.activityName }}
                                  </label>

                                  <!-- FORMS -->
                                  <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                                    <li>

                                      <label :for="form.templateId" class="tree_form">
                                        {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                                      </label>

                                      <input type="checkbox" :id="form.templateId"
                                        @change="viewForms(form.templateId)" />

                                    </li>

                                  </ul>

                                </li>

                              </ul>

                            </div>

                          </li>

                        </ul>

                      </li>

                    </template>

                  </ul>

                </li>

                <!-- ================= VISIT directly under SOA (no phase) ================= -->
                <li v-else-if="soaChild && soaChild.type === 'visit'">

                  <div class="d-flex justify-content-between align-items-center">

                    <div class="w-100">
                      <input type="checkbox" :id="visitInputId(soaChild.visit)"
                        @change="toggleVisit(soaChild.visit.__visitIndex, soaChild.visit.visitId)" />

                      <label class="tree_label" :for="visitInputId(soaChild.visit)">
                        {{ soaChild.visit.visitNo }} : {{ soaChild.visit.visitFormName }}
                      </label>
                    </div>

                    <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">
                      <div class="position-relative">
                        <button :popovertarget="'visit-popup-' + soaChild.visit.visitId"
                          :style="{ anchorName: '--visit-popup-' + soaChild.visit.visitId }"
                          class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                          <i class="fa fa-ellipsis-v"></i>
                        </button>

                        <div :id="'visit-popup-' + soaChild.visit.visitId" popover class="tmf-docs-popup-menu"
                          :style="{ positionAnchor: '--visit-popup-' + soaChild.visit.visitId }"
                          @click.stop>

                          <button class="popup-menu-block text-start"
                            @click.prevent="visitPopup(soaChild.visit.visitId)">
                            {{ $t('navigations.edit') }}
                          </button>

                          <button class="popup-menu-block text-start"
                            @click.prevent="deleteVisit(soaChild.visit.visitId)">
                            {{ $t('navigations.delete') }}
                          </button>

                          <button class="popup-menu-block text-start"
                            @click.prevent="openVisitActivityModal(soaChild.visit.visitId)">
                            {{ $t('navigations.assign activity') }}
                          </button>

                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- ACTIVITIES -->
                  <div v-if="visitExpanded[soaChild.visit.__visitIndex]">

                    <ul v-for="(activity, aIndex) in activityList[soaChild.visit.visitId][soaChild.visit.__visitIndex]"
                      :key="activity.activityId">

                      <li>

                        <input type="checkbox" :id="activity.activityId + soaChild.visit.visitId"
                          @change="getActivityForms(activity.activityId, aIndex)" />

                        <label :for="activity.activityId + soaChild.visit.visitId" class="tree_label">
                          {{ activity.activityOrder }} : {{ activity.activityName }}
                        </label>

                        <!-- FORMS -->
                        <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                          <li>

                            <label :for="form.templateId" class="tree_form">
                              {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                            </label>

                            <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                          </li>

                        </ul>

                      </li>

                    </ul>

                  </div>

                </li>
                <!-- CYCLE directly under SOA -->
                <li v-else-if="soaChild && soaChild.type === 'cycle'">

                  <input type="checkbox" :id="`soa-cycle-${soaChild.cycleId || 'unknown'}-${soaIndex}`" />

                  <label class="tree_label" :for="`soa-cycle-${soaChild.cycleId || 'unknown'}-${soaIndex}`">
                    {{ soaChild.displayText }}
                  </label>

                  <ul>

                    <li v-for="cycleVisit in soaChild.visits" :key="cycleVisit.visitId">

                      <div class="d-flex justify-content-between align-items-center">

                        <div class="w-100">

                          <input type="checkbox" :id="visitInputId(cycleVisit)"
                            @change="toggleVisit(cycleVisit.__visitIndex, cycleVisit.visitId)" />

                          <label class="tree_label" :for="visitInputId(cycleVisit)">
                            {{ cycleVisit.visitNo }} :
                            {{ cycleVisit.visitFormName }}
                          </label>

                        </div>

                        <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">

                          <div class="position-relative">

                            <button :popovertarget="'visit-popup-' + cycleVisit.visitId"
                              :style="{ anchorName: '--visit-popup-' + cycleVisit.visitId }"
                              class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                              <i class="fa fa-ellipsis-v"></i>
                            </button>

                            <div :id="'visit-popup-' + cycleVisit.visitId" popover class="tmf-docs-popup-menu"
                              :style="{ positionAnchor: '--visit-popup-' + cycleVisit.visitId }"
                              @click.stop>

                              <button class="popup-menu-block text-start"
                                @click.prevent="visitPopup(cycleVisit.visitId)">
                                {{ $t('navigations.edit') }}
                              </button>

                              <button class="popup-menu-block text-start"
                                @click.prevent="deleteVisit(cycleVisit.visitId)">
                                {{ $t('navigations.delete') }}
                              </button>

                              <button class="popup-menu-block text-start"
                                @click.prevent="openVisitActivityModal(cycleVisit.visitId)">
                                {{ $t('navigations.assign activity') }}
                              </button>

                            </div>

                          </div>

                        </div>

                      </div>

                      <!-- ACTIVITIES -->
                      <div v-if="visitExpanded[cycleVisit.__visitIndex]">

                        <ul v-for="(activity, aIndex) in activityList[cycleVisit.visitId]?.[cycleVisit.__visitIndex]"
                          :key="activity.activityId">

                          <li>

                            <input type="checkbox" :id="activity.activityId + cycleVisit.visitId"
                              @change="getActivityForms(activity.activityId, aIndex)" />

                            <label :for="activity.activityId + cycleVisit.visitId" class="tree_label">
                              {{ activity.activityOrder }} :
                              {{ activity.activityName }}
                            </label>

                            <!-- FORMS -->
                            <ul v-for="form in formList[activity.activityId]?.[aIndex]" :key="form.templateId">

                              <li>

                                <label :for="form.templateId" class="tree_form">
                                  {{ form.templateName }}  ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                                </label>

                                <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                              </li>

                            </ul>

                          </li>

                        </ul>

                      </div>

                    </li>

                  </ul>

                </li>
              </template>

            </ul>

          </li>

          <!-- ROOT PHASE -->
          <li v-else-if="node && node.type === 'phase'">

            <input type="checkbox" :id="'root-phase-' + node.phaseName" />

            <label class="tree_label" :for="'root-phase-' + node.phaseName">
              {{ node.displayText }}
            </label>

            <ul>

              <template v-for="(child, childIndex) in node.nodes" :key="'root-phase-child-' + childIndex">

                <li v-if="child && child.type === 'visit'">

                  <div class="d-flex justify-content-between align-items-center">

                    <div class="w-100">

                      <input type="checkbox" :id="visitInputId(child.visit)"
                        @change="toggleVisit(child.visit.__visitIndex, child.visit.visitId)" />

                      <label class="tree_label" :for="visitInputId(child.visit)">
                        {{ child.visit.visitNo }} : {{ child.visit.visitFormName }}
                      </label>

                    </div>

                    <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">

                      <div class="position-relative">

                        <button :popovertarget="'visit-popup-' + child.visit.visitId"
                          :style="{ anchorName: '--visit-popup-' + child.visit.visitId }"
                          class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">

                          <i class="fa fa-ellipsis-v"></i>

                        </button>

                        <div :id="'visit-popup-' + child.visit.visitId" popover class="tmf-docs-popup-menu"
                          :style="{ positionAnchor: '--visit-popup-' + child.visit.visitId }" @click.stop>

                          <button class="popup-menu-block text-start" @click.prevent="visitPopup(child.visit.visitId)">
                            {{ $t('navigations.edit') }}
                          </button>

                          <button class="popup-menu-block text-start" @click.prevent="deleteVisit(child.visit.visitId)">
                            {{ $t('navigations.delete') }}
                          </button>

                          <button class="popup-menu-block text-start"
                            @click.prevent="openVisitActivityModal(child.visit.visitId)">
                            {{ $t('navigations.assign activity') }}
                          </button>

                        </div>

                      </div>

                    </div>

                  </div>

                  <!-- ACTIVITIES -->
                  <div v-if="visitExpanded[child.visit.__visitIndex]">

                    <ul v-for="(activity, aIndex) in activityList[child.visit.visitId][child.visit.__visitIndex]"
                      :key="activity.activityId">

                      <li>

                        <input type="checkbox" :id="activity.activityId + child.visit.visitId"
                          @change="getActivityForms(activity.activityId, aIndex)" />

                        <label :for="activity.activityId + child.visit.visitId" class="tree_label">
                          {{ activity.activityOrder }} : {{ activity.activityName }}
                        </label>

                        <!-- FORMS -->
                        <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                          <li>

                            <label :for="form.templateId" class="tree_form">
                              {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                            </label>

                            <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                          </li>

                        </ul>

                      </li>

                    </ul>

                  </div>

                </li>
                <!-- ROOT PHASE CYCLE -->
                <li v-else-if="child && child.type === 'cycle'">

                  <input type="checkbox" :id="`root-phase-cycle-${child.cycleId || 'unknown'}-${childIndex}`" />

                  <label class="tree_label" :for="`root-phase-cycle-${child.cycleId || 'unknown'}-${childIndex}`">
                    {{ child.displayText }}
                  </label>

                  <ul>

                    <li v-for="cycleVisit in child.visits" :key="cycleVisit.visitId">

                      <div class="d-flex justify-content-between align-items-center">

                        <div class="w-100">

                          <input type="checkbox" :id="visitInputId(cycleVisit)"
                            @change="toggleVisit(cycleVisit.__visitIndex, cycleVisit.visitId)" />

                          <label class="tree_label" :for="visitInputId(cycleVisit)">
                            {{ cycleVisit.visitNo }} :
                            {{ cycleVisit.visitFormName }}
                          </label>

                        </div>

                        <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">

                          <div class="position-relative">

                            <button :popovertarget="'visit-popup-' + cycleVisit.visitId"
                              :style="{ anchorName: '--visit-popup-' + cycleVisit.visitId }"
                              class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                              <i class="fa fa-ellipsis-v"></i>
                            </button>

                            <div :id="'visit-popup-' + cycleVisit.visitId" popover class="tmf-docs-popup-menu"
                              :style="{ positionAnchor: '--visit-popup-' + cycleVisit.visitId }"
                              @click.stop>

                              <button class="popup-menu-block text-start"
                                @click.prevent="visitPopup(cycleVisit.visitId)">
                                {{ $t('navigations.edit') }}
                              </button>

                              <button class="popup-menu-block text-start"
                                @click.prevent="deleteVisit(cycleVisit.visitId)">
                                {{ $t('navigations.delete') }}
                              </button>

                              <button class="popup-menu-block text-start"
                                @click.prevent="openVisitActivityModal(cycleVisit.visitId)">
                                {{ $t('navigations.assign activity') }}
                              </button>

                            </div>

                          </div>

                        </div>

                      </div>

                      <!-- ACTIVITIES -->
                      <div v-if="visitExpanded[cycleVisit.__visitIndex]">

                        <ul v-for="(activity, aIndex) in activityList[cycleVisit.visitId]?.[cycleVisit.__visitIndex]"
                          :key="activity.activityId">

                          <li>

                            <input type="checkbox" :id="activity.activityId + cycleVisit.visitId"
                              @change="getActivityForms(activity.activityId, aIndex)" />

                            <label :for="activity.activityId + cycleVisit.visitId" class="tree_label">
                              {{ activity.activityOrder }} :
                              {{ activity.activityName }}
                            </label>

                            <!-- FORMS -->
                            <ul v-for="form in formList[activity.activityId]?.[aIndex]" :key="form.templateId">

                              <li>

                                <label :for="form.templateId" class="tree_form">
                                  {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                                </label>

                                <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                              </li>

                            </ul>

                          </li>

                        </ul>

                      </div>

                    </li>

                  </ul>

                </li>

              </template>

            </ul>

          </li>

          <!-- ROOT VISIT -->
          <li v-else-if="node && node.type === 'visit'">

            <div class="d-flex justify-content-between align-items-center">

              <div class="w-100">

                <input type="checkbox" :id="visitInputId(node.visit)"
                  @change="toggleVisit(node.visit.__visitIndex, node.visit.visitId)" />

                <label class="tree_label" :for="visitInputId(node.visit)">
                  {{ node.visit.visitNo }} : {{ node.visit.visitFormName }}
                </label>

              </div>

              <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">

                <div class="position-relative">

                  <button :popovertarget="'visit-popup-' + node.visit.visitId"
                    :style="{ anchorName: '--visit-popup-' + node.visit.visitId }"
                    class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">

                    <i class="fa fa-ellipsis-v"></i>

                  </button>

                  <div :id="'visit-popup-' + node.visit.visitId" popover class="tmf-docs-popup-menu"
                    :style="{ positionAnchor: '--visit-popup-' + node.visit.visitId }" @click.stop>

                    <button class="popup-menu-block text-start" @click.prevent="visitPopup(node.visit.visitId)">
                      {{ $t('navigations.edit') }}
                    </button>

                    <button class="popup-menu-block text-start" @click.prevent="deleteVisit(node.visit.visitId)">
                      {{ $t('navigations.delete') }}
                    </button>

                    <button class="popup-menu-block text-start"
                      @click.prevent="openVisitActivityModal(node.visit.visitId)">
                      {{ $t('navigations.assign activity') }}
                    </button>

                  </div>

                </div>

              </div>

            </div>

            <!-- ACTIVITIES -->
            <div v-if="visitExpanded[node.visit.__visitIndex]">

              <ul v-for="(activity, aIndex) in activityList[node.visit.visitId][node.visit.__visitIndex]"
                :key="activity.activityId">

                <li>

                  <input type="checkbox" :id="activity.activityId + node.visit.visitId"
                    @change="getActivityForms(activity.activityId, aIndex)" />

                  <label :for="activity.activityId + node.visit.visitId" class="tree_label">
                    {{ activity.activityOrder }} : {{ activity.activityName }}
                  </label>

                  <!-- FORMS -->
                  <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                    <li>

                      <label :for="form.templateId" class="tree_form">
                        {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                      </label>

                      <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                    </li>

                  </ul>

                </li>

              </ul>

            </div>

          </li>

          <!-- ROOT CYCLE -->
          <li v-else-if="node && node.type === 'cycle'">

            <input type="checkbox" :id="'root-cycle-' + node.cycleId" />

            <label class="tree_label" :for="'root-cycle-' + node.cycleId">
              {{ node.displayText }}
            </label>

            <ul>

              <li v-for="cycleVisit in node.visits" :key="cycleVisit.visitId">

                <div class="d-flex justify-content-between align-items-center">

                  <div class="w-100">

                    <input type="checkbox" :id="visitInputId(cycleVisit)"
                      @change="toggleVisit(cycleVisit.__visitIndex, cycleVisit.visitId)" />

                    <label class="tree_label" :for="visitInputId(cycleVisit)">
                      {{ cycleVisit.visitNo }} :
                      {{ cycleVisit.visitFormName }}
                    </label>

                  </div>

                  <div class="d-flex align-items-center gap-3" v-if="optionsshow && rollsprivilages.includes('Study Profile SoA-Actions')">

                    <div class="position-relative">

                      <button :popovertarget="'visit-popup-' + cycleVisit.visitId"
                        :style="{ anchorName: '--visit-popup-' + cycleVisit.visitId }"
                        class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                        <i class="fa fa-ellipsis-v"></i>
                      </button>

                      <div :id="'visit-popup-' + cycleVisit.visitId" popover class="tmf-docs-popup-menu"
                        :style="{ positionAnchor: '--visit-popup-' + cycleVisit.visitId }" @click.stop>

                        <button class="popup-menu-block text-start" @click.prevent="visitPopup(cycleVisit.visitId)">
                          {{ $t('navigations.edit') }}
                        </button>

                        <button class="popup-menu-block text-start" @click.prevent="deleteVisit(cycleVisit.visitId)">
                          {{ $t('navigations.delete') }}
                        </button>

                        <button class="popup-menu-block text-start"
                          @click.prevent="openVisitActivityModal(cycleVisit.visitId)">
                          {{ $t('navigations.assign activity') }}
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

                <!-- ACTIVITIES -->
                <div v-if="visitExpanded[cycleVisit.__visitIndex]">

                  <ul v-for="(activity, aIndex) in activityList[cycleVisit.visitId]?.[cycleVisit.__visitIndex]"
                    :key="activity.activityId">

                    <li>

                      <input type="checkbox" :id="activity.activityId + cycleVisit.visitId"
                        @change="getActivityForms(activity.activityId, aIndex)" />

                      <label :for="activity.activityId + cycleVisit.visitId" class="tree_label">
                        {{ activity.activityOrder }} :
                        {{ activity.activityName }}
                      </label>

                      <!-- FORMS -->
                      <ul v-for="form in formList[activity.activityId]?.[aIndex]" :key="form.templateId">

                        <li>

                          <label :for="form.templateId" class="tree_form">
                            {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                          </label>

                          <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                        </li>

                      </ul>

                    </li>

                  </ul>

                </div>

              </li>

            </ul>

          </li>

        </template>
      </ul>
    </div>
  </div>

  <!-- MODALS -->
  <showformmodel v-if="setshowActivityFormModal" :formid="formActivityId" currentformstatus="not completed"
    @closeformModal="closeformActivityModal()" />

  <VisitActivityModal v-if="showActivityModal" :visitId="SelectedVisitId" :version="selectedVersion"
    @closeModal="closeActivityModal()" />

  <manageVisitModal v-if="showSiteModal" :visitId="visitId" :version="selectedVersion" @closeModal="closeModal()"
    @visitSaved="openVisitActivityModal" />

  <CreateScheduleCyclePopUp v-if="CreateScheduleCyclePopUp" @closeModal="CreateScheduleCyclePopUp = false"
    :patientid="selectedPatientId" :cycleid="selectedCycleId" />
</template>

<script src="./VisitActivityTree.js"></script>

<style scoped>
.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.tmf-docs-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.tmf-docs-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.tmf-docs-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.tmf-docs-popup-menu>button {
  width: 100%;
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.tmf-docs-popup-menu>.popup-menu-block:hover {
  background-color: #e4eaf9;
}

.position-relative .tool-tip {
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 20px;
  top: -10px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
</style>
